import { Link } from "react-router-dom";
import {
  ClipboardCheck, Wrench, Cog, Disc3, Cpu, Snowflake, ArrowRight,
} from "lucide-react";
import { services } from "../mock";

const iconMap = { ClipboardCheck, Wrench, Cog, Disc3, Cpu, Snowflake };

export default function Services() {
  return (
    <section id="servizi" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl mb-12">
          <span className="text-[#e2001a] font-semibold text-sm uppercase tracking-wide">Cosa facciamo</span>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#16181d] mt-2">
            Tutti i servizi per la tua auto
          </h2>
          <p className="text-gray-500 mt-3">
            Un unico punto di riferimento: dalla revisione alla meccanica, dalle gomme
            all'elettrauto. Ci prendiamo cura del tuo veicolo con competenza e trasparenza.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => {
            const Icon = iconMap[s.icon] || Wrench;
            return (
              <div key={s.id} className="group rounded-2xl overflow-hidden border border-gray-100 bg-white card-hover">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <span className="absolute top-3 right-3 bg-white/95 text-[#e2001a] text-xs font-bold px-3 py-1 rounded-full">
                    {s.price}
                  </span>
                  <span className="absolute bottom-3 left-3 inline-flex items-center justify-center w-11 h-11 rounded-xl bg-[#e2001a] text-white">
                    <Icon className="w-5 h-5" />
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-display font-bold text-lg text-[#16181d]">{s.title}</h3>
                  <p className="text-sm text-gray-500 mt-2 leading-relaxed">{s.desc}</p>
                  <a href="#contatti" className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#e2001a] group-hover:gap-2 transition-all">
                    Prenota <ArrowRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
